module.exports = {
  init: function (id) {
    this.target = document.getElementById(id);
    this.screenClassName = "screenPlay";
    if (this.target) {
      this.handleClick();
    }
  },
  template: function () {
    return `<iframe src=${this.target.dataset.iframeUrl} allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"></iframe>`;
  },
  inject: function () {
    this.target.innerHTML = this.template();
  },
  clear: function () {
    this.target.classList.remove(this.screenClassName);
  },
  status: function () {
    return this.target.classList.contains(this.screenClassName);
  },
  handleClick: function () {
    this.target.addEventListener("click", () => {
      if (this.status()) {
        this.clear();
        this.inject();
      }
    });
  }
}